import { TYPE_REMISE_CUMULE } from '@/configuration/devisConf';
import genererGuid from '@/services/general/genererGuid';

export default function genereCgv() {
  return {
    idTempo: genererGuid(),
    libelleRemiseId: '',
    remise: 0,
    type: TYPE_REMISE_CUMULE,
    selected: false,
  };
}
